import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import Pattern from '@mlb/react-patterns/components/LineScore/lineScore.tsx';
import { AnchorElement } from '@mlb/react-patterns/components/Link/link.style.ts';
import Skeleton from '@mlb/react-patterns/components/Skeleton/skeleton.tsx';
import COLORS from '@mlb/react-patterns/style/universal.color';

import { SEARCH_ROUTE } from 'bdvp-common/src/utils/constants';
import { useBasePath } from 'bdvp-common/src/hooks/config';

import { Tracking } from 'bdvp-tracking';

const getSearchParams = (teamId) => {

    return `?q=${encodeURIComponent(`TeamId = [${teamId}] Order by Timestamp DESC`)}`;

};

export const getTeamUrl = (teamId, basePath = '') => {

    if(!teamId) {

        return '';

    }

    return `${basePath}${SEARCH_ROUTE}${getSearchParams(teamId)}`;

};


const HEIGHT = '92px';

const LineScorePattern = styled(Pattern)`
    height: ${HEIGHT};

    ${AnchorElement} {
        color: ${COLORS.mlbWhite};
        &:hover {
            color: ${COLORS.mlbWhite};
            border-bottom: 1px dotted ${COLORS.linkBlue};
        }
    }
`;

const LineScore = (props) => {

    const {
        data,
        loading,
    } = props;

    const basePath = useBasePath();
    const history = useHistory();

    const {
        lineScore,
        home,
        away,
    } = data;

    const getLinkProps = (team) => {

        return {
            url: getTeamUrl(team?.id, basePath),
            handlers: {
                onClick: (e) => {

                    e.preventDefault();
                    Tracking.trackGameIndexPageLineScoreTeamClick(team?.name);

                    history.push({
                        pathname: SEARCH_ROUTE,
                        search: getSearchParams(team?.id),
                    });

                },
            },
        };

    };

    if (loading) {

        return (
            <Skeleton
                borderRadius={0}
                margin={0}
                height={HEIGHT}
                width={'100%'}
            />
        );

    }

    return (

        <LineScorePattern
            inningsData={lineScore.innings}
            totalsData={lineScore}
            homeName={home.abbreviation}
            homeLinkProps={getLinkProps(home)}
            awayName={away.abbreviation}
            awayLinkProps={getLinkProps(away)}
        />

    );

};

LineScore.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
};

LineScore.defaultProps = {
    data: {},
    loading: false,
};

export default LineScore;
